var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
export default function qsa(element, selector) {
  return toArray(element.querySelectorAll(selector));
}


//////////////////
// WEBPACK FOOTER
// ./~/dom-helpers/esm/querySelectorAll.js
// module id = 992
// module chunks = 0